function getCookieDomain() {
  if (typeof window === "undefined") return undefined;

  const host = window.location.hostname;
  if (host === "localhost" || host === "127.0.0.1") return undefined;
  if (host === "rivyoo.org" || host.endsWith(".rivyoo.org")) return ".rivyoo.org";
  if (host === "rivyou.co" || host.endsWith(".rivyou.co")) return ".rivyou.co";
  if (host === "truuh.com" || host.endsWith(".truuh.com")) return ".truuh.com";

  return undefined;
}

export function setCookie(name, value, days = 365) {
  if (typeof document === "undefined") return;

  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  const secure = window.location.protocol === "https:" ? "; Secure" : "";
  const domain = getCookieDomain();
  const domainAttr = domain ? `; domain=${domain}` : "";
  document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/${domainAttr}; SameSite=Lax${secure}`;
}

export function getCookie(name) {
  if (typeof document === "undefined") return null;

  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
}

export function deleteCookie(name) {
  if (typeof document === "undefined") return;

  const domain = getCookieDomain();
  const domainAttr = domain ? `; domain=${domain}` : "";
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/${domainAttr}; SameSite=Lax`;
}
